<template lang="pug">
form#staff-member-form(
  name="staff-member-form"
  @submit.prevent="submit"
  novalidate
)
  .modal-card
    header.modal-card-head
      p.modal-card-title(v-once) {{ title }}
    section.modal-card-body.modal-tabs
      b-tabs(
        position="centered"
        :animated="false"
        expanded
      )
        b-tab-item(label="Details")
          //- b-field(expanded)
          //-   template(slot="label")
          //-     span Link with Speaker Profile
          //-     b-tooltip(
          //-       type="is-dark"
          //-       position="is-right"
          //-       label="When a staff member is linked, key fields are inherited from the speaker profile"
          //-       multilined
          //-     )
          //-       b-icon(icon="help-circle-outline" size="is-small")
          //-   elasticsearch-multiselect(
          //-     :value="staffMember.speaker_id"
          //-     :maxtags="1"
          //-     :allow-new="false"
          //-     placeholder="Search by name..."
          //-     field="full_name"
          //-     icon="microphone"
          //-     index="doxa_speakers"
          //-     @add="addSpeaker"
          //-     @input="setSpeakerId($event, 'speaker_id')"
          //-   )
          b-field(
            label="Name"
            :message="errors.has('full_name') ? errors.first('full_name') : ''"
            :type="errors.has('full_name') ? 'is-danger' : ''"
          )
            b-input(
              type="text"
              name="full_name"
              v-validate="'required'"
              data-vv-as="name"
              :disabled="hasSpeaker"
              :value="staffMember.full_name"
              @input="set($event, 'full_name')"
            )
          b-field(
            label="Title"
            :message="errors.has('title') ? errors.first('title') : ''"
            :type="errors.has('title') ? 'is-danger' : ''"
          )
            b-input(
              type="text"
              name="title"
              v-validate="'required'"
              :value="staffMember.title"
              @input="set($event, 'title')"
            )
          b-field(label="Email")
            b-input(
              type="email"
              name="email"
              icon="email"
              :value="staffMember.email"
              @input="set($event, 'email')"
            )
          b-field(label="Biography")
            b-input(
              type="textarea"
              rows="4"
              :disabled="hasSpeaker"
              :value="staffMember.bio"
              @input="set($event, 'bio')"
            )
        b-tab-item(label="Profile Image")
          cover-art-tab(
            v-model="profileImage"
            :default-image="defaultProfileImage"
            @input="img => profileImage = img"
          )
    footer.modal-card-foot
      button.button.is-success(
        type="submit"
        :class="{ 'is-loading': settings.submitting }"
      ) Save Staff Member
      a.button.is-danger(v-if="!isNew" @click="confirmDelete") Delete
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import CoverArtTab from '@/components/form/episode/CoverArtTab';
import ElasticsearchMultiselect from '@/components/form/ElasticsearchMultiselect';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'staff-member-form',
  components: {
    CoverArtTab,
    ElasticsearchMultiselect,
  },
  computed: {
    ...mapGetters({
      staffMember: getters.GET_STAFF_MEMBER,
    }),
    hasSpeaker() {
      return !_.isEmpty(this.staffMember.speaker_id);
    },
    isNew() {
      return this.staffMember.id === undefined;
    },
    defaultProfileImage() {
      if (this.speakerImage) return this.speakerImage;
      if (this.staffMember._embedded.profile_image.id) {
        return this.staffMember._embedded.profile_image.file.url;
      }
      return null;
    },
    title() {
      return this.isNew ? 'New Staff Member' : `Edit Staff Member: ${this.staffMember.full_name}`;
    },
  },
  data() {
    return {
      profileImage: null,
      settings: {
        loading: false,
        submitting: false,
      },
      speakerFields: [
        'bio',
        'full_name',
      ],
      speakerImage: null,
    };
  },
  methods: {
    async addSpeaker(selected) {
      const { data } = await this.$store.dispatch(actions.DO_GET_SPEAKER, {
        id: selected.id,
        zoom: 'profile_image',
      });
      const speaker = data.speakers[0];
      if (speaker._embedded.profile_image.id !== undefined) {
        this.speakerImage = speaker._embedded.profile_image.file.url;
      }
      this.speakerFields.forEach((field) => {
        this.$store.commit(mutations.SET_STAFF_MEMBER_FIELD, {
          key: field,
          val: speaker[field],
        });
      });
    },
    confirmDelete() {
      this.$buefy.dialog.confirm({
        title: 'Are you sure?',
        message: 'Deleting this staff member cannot be undone',
        type: 'is-danger',
        hasIcon: true,
        confirmText: 'Yes, Delete Staff Member',
        onConfirm: () => this.deleteStaffMember(),
      });
    },
    async deleteStaffMember() {
      const response = await this.$store.dispatch(actions.DO_DELETE_STAFF_MEMBER, {
        id: this.staffMember.id,
        ignore: true,
      });
      this.$parent.close();
      this.$store.commit(mutations.SET_APP_SNACKBAR, {
        type: 'is-success',
        message: response.message,
      });
      this.$store.commit(mutations.SET_MINISTRY_REFRESH, true);
    },
    set(val, key) {
      this.$store.commit(mutations.SET_STAFF_MEMBER_FIELD, {
        key,
        val,
      });
    },
    setSpeakerId(values, key) {
      if (values && values.length > 0) {
        this.$store.commit(mutations.SET_STAFF_MEMBER_FIELD, {
          key,
          val: values[0],
        });
      } else {
        this.$store.commit(mutations.SET_STAFF_MEMBER_FIELD, {
          key,
          val: null,
        });
        this.speakerImage = null;
        this.speakerFields.forEach((field) => {
          this.$store.commit(mutations.SET_STAFF_MEMBER_FIELD, {
            key: field,
            val: null,
          });
        });
      }
    },
    async submit() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        this.settings.submitting = true;
        const action = this.isNew ? actions.DO_CREATE_STAFF_MEMBER : actions.DO_UPDATE_STAFF_MEMBER;
        const payload = {
          id: this.staffMember.id,
          email: this.staffMember.email,
          title: this.staffMember.title,
          zoom: 'profile_image',
        };
        if (this.staffMember.speaker_id) {
          payload.speaker_id = this.staffMember.speaker_id;
        } else {
          payload.bio = this.staffMember.bio;
          payload.full_name = this.staffMember.full_name;
          if (this.profileImage) {
            const file = this.profileImage.generateDataUrl('image/jpeg');
            const { data } = await this.$store.dispatch(actions.DO_CREATE_MEDIA_IMAGE, { file });
            payload.profile_image_id = data.images[0].id;
          }
        }
        try {
          const response = await this.$store.dispatch(action, payload);
          this.$parent.close();
          this.$store.commit(mutations.SET_APP_SNACKBAR, {
            type: 'is-success',
            message: response.message,
          });
          this.settings.submitting = false;
          this.$store.commit(mutations.SET_MINISTRY_REFRESH, true);
        } catch (error) {
          this.settings.submitting = false;
          this.$store.commit(mutations.SET_APP_SNACKBAR, {
            type: 'is-danger',
            message: error.response.data.data.error_message,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/StaffMemberForm.vue